import { LMS_WEBAPP_CONFIG_IMPL } from "../../../infecto-lms-webapp-impl/config";

export const urlToIdentityWithBrandIdAndOrigin = `${process.env.REACT_APP_USER_SYSTEM_BASE}/login/${LMS_WEBAPP_CONFIG_IMPL.brandId}/?origin=${process.env.REACT_APP_REDIRECT_BASE_64_APP_BASE}`;
